import { Component } from "react";

import BillService from "../../services/Bill";
import SocieteService from "../../services/Societe";
import ErrorAlert from "../../components/layouts/ErrorAlert";
import MethodePayement from "./payement/MethodePayementBC";

class PayementAllBills extends Component {
  state = {
    retenu: "",
    ChoosePayement: "",
    certificatRetenu: false,
    buttonClicked: "",
    bills: [],
    societe: "",
    amountToBePayed: 0.0,
  };
  constructor(props) {
    super(props);
    this.state = {
      retenu: "",
      ChoosePayement: "",
      certificatRetenu: false,
      buttonClicked: "",
      bills: [],
      societe: "",
      amountToBePayed: 0.0,
    };
    // this.calculeAmount = this.calculeAmount.bind(this);
  }
  componentDidMount() {
    this.forceUpdate();
    BillService.allBillsPayed(
      localStorage.getItem("idSociete"),

      localStorage.getItem("isIncome"),
      0,
      1,
      0
    )
      .then((response) => {
        console.log("response", response.data["Bill"]);
        if (response.data["Bill"] === "vide") {
          this.setState({ alert_message: "error" });
        } else {
          console.log("In bill else");
          console.log("response", response.data["Bill"]);
          this.setState({ bills: response.data["Bill"] });
          console.log("bill", this.state.bills);
          this.setState({ alert_message: "success" });
        }
      })
      .catch((error) => {
        //original  this.setState({ alert_message: "error" });
        this.setState({
          bills: [
            {
              id: 2,
              refBill: "InpayedBill1",
              titleBill: "InpayedBill1",
              societeCliente: { id: 10, title: "client1" },
              echeanceDate: "1996-12-17T03:24:00",
              isPayed: 1,
              amountTT: 100,
              description: "testtt",
              urlFile: "https://iware.info/",
            },
          ],
        });
      });

    BillService.amountTTAllBillsPayed(
      localStorage.getItem("idSociete"),

      localStorage.getItem("isIncome"),
      0,
      1,
      0
    )
      .then((response) => {
        console.log("response", response.data["Bill"]);
        if (response.data["Bill"] === "vide") {
          this.setState({ alert_message: "error" });
        } else {
          console.log("In bill else");
          console.log("response", response.data["Bill"]);
          this.setState({ amountTTAllBillsPayed: response.data["Bill"] });
          console.log(
            "amountTTAllBillsPayed",
            this.state.amountTTAllBillsPayed
          );
          this.setState({ alert_message: "success" });
        }
      })
      .catch((error) => {
        //original  this.setState({ alert_message: "error" });
        this.setState({ amountTTAllBillsPayed: 555 });
      });

    SocieteService.getSocieteById(localStorage.getItem("idSociete"))
      .then((response) => {
        console.log("response", response.data["Societe"]);
        if (response.data["Societe"] === "erreur") {
          this.setState({ alert_message: "error" });
        } else {
          console.log("In SocietebyId else");
          console.log("response", response.data["Societe"]);
          this.setState({ societe: response.data["Societe"] });
          console.log("Societe", this.state.societe);
          this.setState({ alert_message: "success" });
        }
      })
      .catch((error) => {
        //original  this.setState({ alert_message: "error" });
      });
  }
  payementChooseUI() {
    if (this.state.ChoosePayement === "TOTAL") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-info">
                <div className="card-header">
                  <h3 className="card-title">2-Deuxième étape:</h3>
                </div>

                <MethodePayement
                  type="TOTAL"
                  idBill={localStorage.getItem("idBill")}
                />

                {/* </div> */}
              </div>
            </div>
          </div>
        </section>
      );
    } else if (this.state.ChoosePayement === "AVANCE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="box box-info">
              <div className="box-header">
                <h3 className="box-title">
                  Deuxième étape:{" "}
                  <h5>Choisir le mode de payement de l'avance </h5>
                </h3>
              </div>

              <MethodePayement
                type="AVANCE"
                idBill={localStorage.getItem("idBill")}
              />
            </div>
          </div>
          <div class="col-md-12">
            <div className="box box-info">
              <div className="box-header">
                <h3 className="box-title">
                  Troisième étape:{" "}
                  <h5>Choisir le mode de payement du reste du montant </h5>
                </h3>
              </div>
              <MethodePayement
                type="TOTAL"
                idBill={localStorage.getItem("idBill")}
              />
            </div>
          </div>
        </div>
        // </section>
      );
    }
  }
  handleChangePayement = (e) => {
    let payement = e.target.value;
    this.setState({
      ChoosePayement: payement,
    });
    console.log("methode Payement", this.state.ChoosePayement);
  };
  DynamiquePayement() {
    if (this.state.buttonClicked === "clicked") {
      return (
        
          <section class="content">
            <div class="row">
              {/* <div class="col-md-1"></div> */}
              <div className="col-12">
                <div className="card card-success">
                  <div className="card-header">
                    <h3 className="card-title">1-Première étape:</h3>
                    <br />
                  </div>

                  <div className="card-body">
                    <h5 className="card-title">
                      Choisir de payer la totalité du montant ou une avance
                    </h5>
                    <div class="row">
                      <div class="col-2"></div>
                      <div class="col-10">
                        <select
                          class="form-control"
                          onChange={this.handleChangePayement}
                        >
                          <option key={0} value={0}>
                            Payer
                          </option>
                          <option key={1} value={"TOTAL"}>
                            La totalité du montant
                          </option>
                          <option key={2} value={"AVANCE"}>
                            Une avance
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.payementChooseUI()}
          </section>
      
      );
    }
  }

  certificat(event) {
    this.setState({ certificatRetenu: true });
  }

  formatDate(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate() + 1).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return day + "/" + month + "/" + year;
  }
  render() {
    if (this.state.alert_message === "error") {
      return (
        <div className="content-wrapper">
          <section class="content">
            <div class="row">
              <div class="col-md-12">
                <ErrorAlert message="Désolé aucune facture à afficher" />
              </div>
            </div>
          </section>
        </div>
      );
    } else {
      return (
        <div className="content-wrapper">
          <section class="content">
            <br />
            <div className="card card-primary">
              <div className="card-header with-border">
                <h3 className="card-title">Les factures du client:</h3>
              </div>

              <div className="card-body">
                {this.state.bills.map((bill) => (
                  <div className="row">
                    <div className="user-block">
                      Facture {bill.refBill} - {bill.title}
                      <br />
                      Date de facture : {this.formatDate(bill.echeanceDate)}
                      <a
                      style={{marginLeft : 870}}
                        href={bill.urlFile}
                        className="link-black text-sm float-right"
                      >
                        <i className="fas fa-link mr-1" /> Télécharger la
                        facture
                      </a>
                      <br />
                      Montant :{bill.amountTT} DNT
                      <br />
                      <span className="product-description">
                        {bill.description}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div class="card-footer">
                <button
                  type="submit"
                  onClick={(e) => {
                    if (
                      this.state.amountToBePayed >= this.state.retenu &&
                      window.confirm(
                        "Voulez vous obtenir une certificat de retenu?"
                      )
                    ) {
                      this.certificat(e);
                    }
                    this.setState({ buttonClicked: "clicked" });
                  }}
                  className="btn btn-info float-right"
                >
                  Commencer le payement
                </button>
              </div>
            </div>
            {/* </div>
            </div> */}
           
          </section>

     
          {this.DynamiquePayement()}
      
        </div>
      );
    }
  }
}
export default PayementAllBills;
